var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.shortcutItems.length > 1
    ? _c("div", { staticClass: "header-dots" }, [
        _c(
          "span",
          { attrs: { slot: "button-content" }, slot: "button-content" },
          [
            _c(
              "q-btn",
              {
                staticClass: "toptabshort",
                attrs: {
                  flat: "",
                  dense: "",
                  round: "",
                  color: "white",
                  icon: "launch",
                },
              },
              [
                _c(
                  "q-tooltip",
                  { attrs: { anchor: "center left", self: "center right" } },
                  [_vm._v(" 사이트 즐겨찾기 ")]
                ),
                _c(
                  "q-menu",
                  {
                    attrs: {
                      anchor: "bottom left",
                      self: "top middle",
                      "auto-close": "",
                      "transition-show": "jump-down",
                      "transition-hide": "jump-up",
                    },
                  },
                  [
                    _c(
                      "q-list",
                      { staticClass: "topMenuShort" },
                      _vm._l(_vm.shortcutItems, function (tag) {
                        return _c(
                          "q-item",
                          {
                            directives: [
                              { name: "ripple", rawName: "v-ripple" },
                            ],
                            key: tag.shortcutId,
                            ref: "tag",
                            refInFor: true,
                            attrs: { clickable: "", name: tag.title },
                            on: {
                              click: function ($event) {
                                return _vm.setShortcut(tag)
                              },
                            },
                          },
                          [
                            _c(
                              "q-item-section",
                              [
                                _c("q-item-label", { attrs: { lines: "1" } }, [
                                  _vm._v(_vm._s(tag.title)),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }